var _typeOf = function typeOf(value) {
  var toString = Object.prototype.toString;

  _typeOf = function typeOf(value) {
    return toString.call(value).slice(8, -1);
  };

  return toString.call(value).slice(8, -1);
};

export { _typeOf as typeOf };

var isSameType = function isSameType(type) {
  return function (value) {
    return _typeOf(value) === type;
  };
};

export var isBoolean = isSameType('Boolean');
export var isUndefined = isSameType('Undefined');